/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Debtor_CompanyInputs */

const en_case_debtor_company = /** @type {(inputs: Case_Debtor_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const pt_br2_case_debtor_company = /** @type {(inputs: Case_Debtor_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pessoa jurídica`)
};

/**
* | output |
* | --- |
* | "Company" |
*
* @param {Case_Debtor_CompanyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_debtor_company = /** @type {((inputs?: Case_Debtor_CompanyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Debtor_CompanyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_debtor_company(inputs)
	return pt_br2_case_debtor_company(inputs)
});